import React from 'react';

export default function CalcPageText() {
  return (
    <p className="calcParagraph">Let&apos;s do some Maths!</p>
  );
}
